import { colors } from '@yorukiri/ui/tokens';

export function EditorStyles() {
  return (
    <style>{`
      .tiptap {
        outline: none;
        min-height: 400px;
        font-size: 15.5px;
        line-height: 1.65;
        color: ${colors.ink2};
      }
      .tiptap > * + * { margin-top: 14px; }
      .tiptap p { margin: 0; max-width: 62ch; }
      .tiptap h1 {
        font-size: 40px; font-weight: 600; letter-spacing: -0.02em;
        line-height: 1.1; color: ${colors.ink}; margin-top: 32px;
      }
      .tiptap h2 {
        font-size: 30px; font-weight: 600; letter-spacing: -0.018em;
        line-height: 1.15; color: ${colors.ink}; margin-top: 28px;
      }
      .tiptap h3 {
        font-size: 22px; font-weight: 600; letter-spacing: -0.01em;
        line-height: 1.2; color: ${colors.ink}; margin-top: 24px;
      }
      .tiptap ul, .tiptap ol { padding-left: 22px; max-width: 62ch; }
      .tiptap li { margin: 4px 0; }
      .tiptap li::marker { color: ${colors.ink3}; }
      .tiptap blockquote {
        border-left: 2px solid ${colors.accent};
        padding-left: 16px; margin: 22px 0;
        font-style: italic; font-weight: 500; font-size: 20px; line-height: 1.4;
        color: ${colors.ink}; max-width: 54ch;
      }
      .tiptap hr {
        border: none; border-top: 1px solid ${colors.line2};
        margin: 28px 0;
      }
      .tiptap pre {
        background: ${colors.surface2};
        border: 1px solid ${colors.line2};
        border-radius: 8px;
        padding: 14px 16px;
        font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
        font-size: 12.5px; line-height: 1.55;
        color: ${colors.ink}; max-width: 64ch; overflow-x: auto;
      }
      .tiptap code {
        background: rgba(24,22,15,0.06);
        border-radius: 3px; padding: 1px 5px;
        font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
        font-size: 0.88em;
      }
      .tiptap pre code { background: transparent; padding: 0; }

      .tiptap .cloze {
        background: linear-gradient(180deg, transparent 58%, rgba(176, 138, 42, 0.26) 58%);
        padding: 0 2px;
        color: ${colors.ink};
        font-weight: 500;
        border-bottom: 1px dotted rgba(176, 138, 42, 0.6);
        position: relative;
      }

      .tiptap .callout {
        background: ${colors.warnSoft};
        border: 1px solid rgba(176, 138, 42, 0.22);
        border-radius: 8px;
        padding: 14px 18px 16px;
        display: grid;
        grid-template-columns: auto 1fr;
        gap: 14px;
        max-width: 64ch;
        margin: 22px 0;
      }
      .tiptap .callout-icon {
        width: 26px; height: 26px;
        border-radius: 6px;
        background: rgba(255,255,255,0.6);
        display: flex; align-items: center; justify-content: center;
        font-size: 14px;
        user-select: none;
        margin-top: 2px;
      }
      .tiptap .callout-body > * { margin: 0 !important; }
      .tiptap .callout-body > * + * { margin-top: 8px !important; }

      .tiptap p.is-editor-empty:first-child::before {
        content: attr(data-placeholder);
        color: ${colors.ink3};
        pointer-events: none;
        float: left;
        height: 0;
      }

      .tiptap p.is-empty::before {
        content: attr(data-placeholder);
        color: ${colors.ink3};
        opacity: 0.5;
        pointer-events: none;
        float: left;
        height: 0;
      }

      .tiptap-bubble {
        display: flex;
        gap: 2px;
        background: ${colors.ink};
        color: ${colors.surface};
        padding: 4px;
        border-radius: 8px;
        box-shadow: 0 12px 40px -12px rgba(17,17,20,0.2);
      }
      .tiptap-bubble button {
        background: transparent;
        border: none;
        color: inherit;
        padding: 5px 9px;
        border-radius: 5px;
        cursor: pointer;
        font-size: 12.5px;
        font-family: inherit;
        display: inline-flex;
        align-items: center;
      }
      .tiptap-bubble button:hover { background: rgba(255,255,255,0.08); }
      .tiptap-bubble button.active { background: rgba(255,255,255,0.15); color: ${colors.surface}; }

      .tiptap .page-link {
        display: inline-flex;
        align-items: baseline;
        gap: 6px;
        padding: 1px 6px 1px 4px;
        background: ${colors.accentSoft};
        color: ${colors.accent};
        border-radius: 5px;
        text-decoration: none;
        font-weight: 500;
        font-size: 0.92em;
        cursor: pointer;
        border-bottom: 1px solid transparent;
      }
      .tiptap .page-link:hover { border-bottom-color: ${colors.accent}; }
      .tiptap .page-link-icon { font-size: 0.85em; user-select: none; }
      .tiptap .page-link-title { letter-spacing: -0.005em; }

      .tiptap [data-math="block"] {
        margin: 18px 0;
        max-width: 64ch;
      }
      .tiptap [data-math="inline"] .katex {
        font-size: 1em;
      }
      .tiptap [data-math="block"] .katex-display {
        margin: 0;
      }

      .tiptap .card-block {
        display: block;
        background: ${colors.surface};
        border: 1px solid ${colors.line2};
        border-radius: 8px;
        padding: 9px 13px;
        margin: 12px 0;
        max-width: 64ch;
        transition: border-color 0.12s, box-shadow 0.12s;
        cursor: default;
      }
      .tiptap .card-block:hover {
        border-color: ${colors.ink3};
      }
      .tiptap .card-block[data-selected="true"] {
        border-color: ${colors.accent};
        box-shadow: 0 0 0 3px ${colors.accentSoft};
      }
      .tiptap .card-block[data-card-type="mcq"] {
        background: rgba(52, 168, 83, 0.03);
        border-color: rgba(52, 168, 83, 0.22);
      }
      .tiptap .card-block[data-card-type="cloze"] {
        background: rgba(176, 138, 42, 0.04);
        border-color: rgba(176, 138, 42, 0.22);
      }

      .tiptap .card-block-compact-basic {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 13.5px;
        line-height: 1.4;
      }
      .tiptap .card-block-compact-front {
        font-weight: 500;
        color: ${colors.ink};
      }
      .tiptap .card-block-compact-back {
        color: ${colors.ink2};
        font-style: italic;
      }
      .tiptap .card-block-compact-arrow {
        color: ${colors.ink3};
        flex-shrink: 0;
      }
      .tiptap .card-block-compact-cloze {
        font-size: 13.5px;
        line-height: 1.5;
        color: ${colors.ink};
      }
      .tiptap .card-block-compact-mcq {
        font-size: 13px;
        line-height: 1.45;
      }
      .tiptap .card-block-compact-question {
        font-weight: 500;
        color: ${colors.ink};
        margin-bottom: 4px;
      }
      .tiptap .card-block-compact-options {
        margin: 0;
        padding: 0;
        list-style: none;
        display: flex;
        flex-direction: column;
        gap: 1px;
      }
      .tiptap .card-block-compact-options li {
        display: grid;
        grid-template-columns: 14px 1fr;
        gap: 6px;
        font-size: 12.5px;
        color: ${colors.ink3};
      }
      .tiptap .card-block-compact-options li.correct {
        color: ${colors.good};
        font-weight: 500;
      }
      .tiptap .card-block-compact-options .marker {
        font-variant-numeric: tabular-nums;
      }
      .tiptap .card-block em {
        color: ${colors.ink3};
        font-style: italic;
        opacity: 0.7;
      }
      .tiptap .card-block-type {
        font-variant-numeric: tabular-nums;
        font-size: 9.5px;
        letter-spacing: 0.12em;
        text-transform: uppercase;
        color: ${colors.ink3};
        font-weight: 500;
      }
      .tiptap .cloze-inline {
        background: linear-gradient(180deg, transparent 58%, rgba(176, 138, 42, 0.26) 58%);
        padding: 0 2px;
        border-bottom: 1px dotted rgba(176, 138, 42, 0.6);
        font-weight: 500;
      }

      .tiptap .media-block {
        margin: 14px 0;
        border-radius: 8px;
        overflow: hidden;
        border: 1px solid ${colors.line2};
        background: ${colors.surface};
      }
      /* Image blocks shrink to the resized width so the border hugs the image
         instead of spanning the full column. */
      .tiptap .media-block[data-kind="image"] {
        width: fit-content;
        max-width: 100%;
        border: none;
        background: transparent;
        overflow: visible;
      }
      .tiptap .media-image-wrap {
        position: relative;
        display: block;
        margin: 0;
        user-select: none;
        border-radius: 8px;
        overflow: hidden;
        border: 1px solid ${colors.line2};
        background: ${colors.surface};
      }
      .tiptap .media-image {
        display: block;
        width: 100%;
        height: auto;
      }
      .tiptap .resizable-handle {
        position: absolute;
        right: 4px;
        bottom: 4px;
        width: 18px;
        height: 18px;
        border-radius: 4px;
        background: ${colors.accent};
        border: 2px solid ${colors.surface};
        box-shadow: 0 2px 6px rgba(24,22,15,0.25);
        cursor: nwse-resize;
        opacity: 0.9;
        z-index: 2;
      }
      .tiptap .resizable-handle:hover {
        opacity: 1;
      }
      .tiptap .resizable-presets {
        position: absolute;
        top: 8px;
        right: 8px;
        display: flex;
        gap: 2px;
        padding: 3px;
        background: rgba(24,22,15,0.78);
        border-radius: 6px;
        backdrop-filter: blur(6px);
        z-index: 2;
      }
      .tiptap .resizable-presets button {
        background: transparent;
        color: rgba(255,255,255,0.72);
        border: none;
        padding: 3px 9px;
        border-radius: 4px;
        font-size: 11px;
        font-family: inherit;
        font-weight: 500;
        letter-spacing: 0.04em;
        cursor: pointer;
      }
      .tiptap .resizable-presets button:hover {
        background: rgba(255,255,255,0.12);
        color: #fff;
      }
      .tiptap .resizable-presets button.active {
        background: ${colors.accent};
        color: #fff;
      }
      .tiptap .media-audio {
        padding: 14px 16px;
      }
      .tiptap .media-audio audio {
        width: 100%;
      }
      .tiptap .media-caption {
        font-size: 11.5px;
        color: ${colors.ink3};
        padding: 6px 14px;
        border-top: 1px solid ${colors.line};
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;
      }
      .tiptap .media-pdf {
        display: flex;
        flex-direction: column;
      }
      .tiptap .media-pdf-frame {
        width: 100%;
        height: 480px;
        border: none;
        background: ${colors.surface2};
      }
      .tiptap .media-open {
        color: ${colors.accent};
        text-decoration: none;
        font-size: 11.5px;
      }

      .tiptap .embed-block {
        margin: 14px 0;
        border-radius: 8px;
        overflow: hidden;
        border: 1px solid ${colors.line2};
        background: ${colors.surface};
      }
      .tiptap .embed-frame {
        position: relative;
        width: 100%;
        height: 0;
        background: ${colors.surface2};
      }
      .tiptap .embed-frame iframe {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        border: none;
      }
      .tiptap .embed-caption {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 6px 12px;
        border-top: 1px solid ${colors.line};
        font-size: 11.5px;
      }
      .tiptap .embed-provider {
        font-variant-numeric: tabular-nums;
        font-size: 10px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: ${colors.accent};
        background: ${colors.accentSoft};
        padding: 2px 7px;
        border-radius: 3px;
        font-weight: 500;
      }
      .tiptap .embed-open {
        color: ${colors.ink3};
        text-decoration: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex: 1;
      }
      .tiptap .embed-open:hover {
        color: ${colors.ink};
      }
      .tiptap .embed-link-card {
        display: flex;
        flex-direction: column;
        gap: 4px;
        padding: 18px 20px;
        text-decoration: none;
        color: ${colors.ink};
        background: ${colors.surface2};
      }
      .tiptap .embed-link-host {
        font-size: 10px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: ${colors.ink3};
      }
      .tiptap .embed-link-url {
        font-size: 13.5px;
        color: ${colors.ink2};
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .tiptap .embed-link-open {
        font-size: 11.5px;
        color: ${colors.accent};
        margin-top: 4px;
      }
    `}</style>
  );
}
